<template>
    <NavbarHome3 />
    <Breadcrumb mainTitle="Pravila o postupku pred sudom časti" subTitle="Pravila o postupku pred sudom časti" />
    <div style="margin: 100px;">
        <AboutTab5 />
    </div>
    <Footer />
  </template>
  
  <script>
  // @ is an alias to /src
  import NavbarHome3 from "@/components/NavbarHome3.vue";
  import Breadcrumb from "@/components/Breadcrumb.vue";
  import Footer from "@/components/Footer.vue";
  import AboutTab5 from "@/views/AboutTab5.vue";
  
  export default {
    name: "Statut",
    components: { NavbarHome3, Breadcrumb, Footer, AboutTab5 },
  
    async mounted() {
      //scrolling to top of the window
      window.scrollTo(0, 0);
    },
  };
  </script>
  <script setup>
  import { useSeoMeta } from "@vueuse/head";
  useSeoMeta({
    title: "Pravila o postupku pred sudom časti | UPUFBiH",
    description: "Pravila o postupku pred sudom časti | UPUFBiH",
    ogDescription: "Pravila o postupku pred sudom časti | UPUFBiH",
    ogTitle: "Pravila o postupku pred sudom časti | UPUFBiH",
  });
  </script>
  